import React, { useState } from 'react';
import Chatbot from 'react-chatbot-kit';
import 'react-chatbot-kit/build/main.css';
import config from './chatbot/config';
import MessageParser from './chatbot/MessageParser';
import ActionProvider from './chatbot/ActionProvider';

export default function ChatBotAssistant() {
  const [showChat, setShowChat] = useState(false);

  return (
    <div style={{ position: 'fixed', bottom: 80, right: 20, zIndex: 1000 }}>
      {showChat && (
        <div style={{ boxShadow: '0 0 12px rgba(0,0,0,0.2)' }}>
          <Chatbot
            config={config}
            messageParser={MessageParser}
            actionProvider={ActionProvider}
          />
        </div>
      )}

      <button
        className="btn btn-success mt-2"
        onClick={() => setShowChat((prev) => !prev)}
        style={{
          width: 60,
          height: 60,
          borderRadius: '50%',
          position: 'absolute',
          bottom: showChat ? '100%' : 0,
          right: 0,
        }}
        title={showChat ? 'Close chat' : 'Open AI Assistant'}
      >
        {showChat ? '✕' : '💬'}
      </button>
    </div>
  );
}
